export default __webpack_public_path__ + "static/media/The Kruks Photography-843.e6d9f0d0.jpg";